




























import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { isIos } from "@/utils/lodash";

@Component({
  components: {},
  directives: {
    focus: {
      inserted: (el, binding) => {
        if (binding.value) {
          el.focus();
        }
      }
    }
  }
})
export default class InputField extends Vue {
  @Prop({ default: "" })
  private placeholderText?: string;
  @Prop({ default: "text" })
  private inputType?: string;
  @Prop({ default: 100 })
  private maxTextLength?: number;
  @Prop({ default: true })
  private border?: boolean;
  @Prop({ default: false })
  private autofocus?: boolean;
  @Prop({ default: false })
  private autoFocused?: boolean;
  @Prop()
  private value?: any;

  private inputValue: string | number = "";

  @Watch("autoFocused", { immediate: true })
  private watchAutoFocused(val: boolean) {
    if (val) {
      this.$nextTick(() => {
        (this.$refs.inputDom as HTMLElement).focus();
      });
    }
  }

  @Watch("value")
  private watchValue(val: any) {
    this.inputValue = val;
  }

  @Watch("inputValue", { immediate: true })
  private onChildChanged(val: string, oldVal: string) {
    this.$emit("input", val);
  }

  private focusCall(e: any) {
    this.$emit("focus");
    // setTimeout(() => {
    //   if (isIos()) {
    //     e.target.scrollIntoView(true);
    //     e.target.scrollIntoViewIfNeeded();
    //     (document.activeElement as any).scrollIntoViewIfNeeded(true);
    //   }
    // }, 50);
  }

  private blurCall() {
    this.$emit("blur");
  }

  private keyUp() {
    this.$emit("keyUp", this.inputValue);
  }

  private _keydown(val: any) {
    console.log("_keydown", val);
    this.$emit("input", val.data);
  }

  @Emit("clickClear")
  private clickClear() {
    this.inputValue = "";
  }
}
